import { useQuery } from 'react-query';
import { AuthenticatedUser } from '../../../../../../../shared/types';
import { useTelemetryContext } from '../../../../../../../telemetry/telemetryContext';
import ImageProcessingApi from '../../../api/ImageProcessingApi';
import { getUserInfo } from '../../../../../../../telemetry/utils';

export type IOrderRowQuantitiesInfo = {
    orderRowId: number;
    expectedQuantity: number;
    isUploadable: number;
    productName: string;
};

type PhotoStatusResponse = {
    normalImagesAvailable: boolean;
    isCorrectNumberOfImages: boolean;
    currentStatus: number;
    canReapprove: boolean;
    orderRowQuantitiesInfo: IOrderRowQuantitiesInfo[];
};

type IPhotoStatusQueryArgs = {
    orderId: number;
    user: AuthenticatedUser;
    enabled?: boolean;
};

export let photoStatusQueryKey = 'customer-image-processing-page-get-photo-status';

export function usePhotoStatusQuery({ orderId, user, enabled = true }: IPhotoStatusQueryArgs) {
    let { logger } = useTelemetryContext();

    let { data, isLoading } = useQuery<PhotoStatusResponse>(
        [photoStatusQueryKey, { orderId }],
        () => ImageProcessingApi.getPhotoStatus(orderId),
        {
            useErrorBoundary: true,
            enabled,
            onError: (error) => {
                let additionalInfo = {
                    origin: 'CustomerImageProcessingPage.Query.getPhotoStatus',
                    userInfo: getUserInfo(user)
                };
                logger.logException(error, additionalInfo);
            }
        }
    );

    return { data: data != null ? data : null, isLoading };
}
